import { Component, OnInit } from '@angular/core';
import { SubheaderHandlerService } from '../../services/subheader-handler.service';


@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {

  public  subheaderData = {
    leftSection: {
      type: 'breadcrumb',
      data: []
    },
    rightSection: {
      type: '',
      data: [],
      className: ''
    },
  };

  constructor(private subHeaderService: SubheaderHandlerService) {
    this.subHeaderService.updateLeftSection(this.subheaderData.leftSection);
    this.subHeaderService.updateRightSection(this.subheaderData.rightSection);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/page-not-found/page-not-found.component.ts